
import React, { useMemo } from "react";
import ProductCard from "./ProductCard";
import NoResults from "./NoResults";
import { Product } from "./ShopTypes";

interface ProductsGridProps {
  products: Product[];
  searchQuery: string;
  onClearSearch: () => void;
}

const ProductsGrid: React.FC<ProductsGridProps> = ({ products, searchQuery, onClearSearch }) => {
  // Rearrange products to place Breathe Naturals products side by side
  const arrangedProducts = useMemo(() => {
    if (products.length === 0) return [];
    
    // The products are already arranged in the desired order from the ShopTypes file
    // No rearrangement needed as we've moved Hey Humans to the top in the source data
    return products;
  }, [products]);

  return (
    <div className="grid grid-cols-1 gap-6 mt-10">
      {arrangedProducts.length > 0 ? (
        arrangedProducts.map(product => (
          <ProductCard key={product.id} product={product} />
        ))
      ) : (
        <NoResults searchQuery={searchQuery} onClearSearch={onClearSearch} />
      )}
    </div>
  );
};

export default ProductsGrid;
